import $ from "jquery";

/**
 * @param {string} type - "error" ou autre (notice/success)
 * @param {string} message - texte du message (pas de HTML nécessaire)
 * @param {Object} [options]
 * @param {string} [options.actionLabel] - libellé d'un bouton d'action optionnel (ex: "Afficher les erreurs")
 * @param {Function} [options.actionCallback] - callback appelé au clic sur ce bouton
 * @param {number} [options.timeout] - durée d'affichage en ms (défaut : 7000 pour error, 5000 sinon)
 */
function showFlash(type, message, options = {}) {
  const { actionLabel, actionCallback } = options;
  const id = type === "error" ? "fx-conteneur-error" : "fx-conteneur-notice";
  const flashClass =
    type === "error"
      ? "fx-flash-top-right fx-flash-error fx-flash-message"
      : "fx-flash-top-right fx-flash-success fx-flash-message";

  // Supprime les anciens messages du même type
  $(`#${id}`).remove();

  const actionHtml = actionLabel
    ? `<button type="button" class="fx-flash-action-btn">${actionLabel}</button>`
    : "";

  // Erreur : reste affichée plus longtemps (message souvent plus long à lire,
  // et il faut le temps de repérer le bouton d'action éventuel).
  const timeout = options.timeout || (type === "error" ? 7000 : 5000);

  // Injecte le HTML
  const html = `
    <div id="${id}" class="${flashClass}"
         data-controller="flash"
         data-flash-target="container"
         data-flash-timeout-value="${timeout}"
         data-action="mouseenter->flash#mouseenter mouseleave->flash#mouseleave">
      <button class="fx-flash-close-button" data-action="flash#dismissManually">&times;</button>
      <div class="fx-inline-message"><span>${message}</span>${actionHtml}</div>
      <div class="fx-progress-bar" data-flash-target="progressBar"></div>
    </div>
  `;
  $("body").append(html);

  // Callback branché en vrai listener JS (pas d'onclick en string) : évite
  // tout souci d'échappement de guillemets imbriqués et fonctionne même si
  // le message ou le libellé contiennent des caractères spéciaux.
  if (actionLabel && typeof actionCallback === "function") {
    const btn = document.querySelector(`#${id} .fx-flash-action-btn`);
    if (btn) {
      btn.addEventListener("click", (event) => {
        actionCallback(event);
        // Ferme le toast automatiquement : on clique son propre bouton fermer
        // pour réutiliser exactement la même logique (fade-out via flash#dismissManually)
        // plutôt que de dupliquer l'animation de fermeture ici.
        document.querySelector(`#${id} .fx-flash-close-button`)?.click();
      });
    }
  }
}

// Rendre accessible globalement
window.showFlash = showFlash;
